import React, { useEffect } from 'react';
import Text from '../../../../atoms/Text';
import ReactTooltip from 'react-tooltip';

interface IModalInputProps {
  type?: React.HTMLInputTypeAttribute;
  value: string;
  setValue(value: string): void;
  error?: string;
  resetError?(): void;
  loading: boolean;
  label: string;
  info: string;
  icon: string;
  placeholder?: string;
}

const ModalInput = ({
  type,
  value,
  setValue,
  error,
  resetError,
  label,
  loading,
  info,
  icon,
  placeholder,
}: IModalInputProps) => {
  useEffect(() => {
    if (!error) {
      ReactTooltip.rebuild();
    }
  }, [error]);

  return (
    <div>
      <div className='cex_wallet__connect__label'>
        <Text size={12} className='text--grey-400 text--weight-500'>
          {label}
        </Text>
        {error ? (
          <Text size={12} className='text--red-600 text--weight-500'>
            {error}
          </Text>
        ) : (
          <div
            className='cex_wallet__connect__label__icon icon-alert-circle'
            data-for={`modal-input-tooltip-${label}`}
            data-tip={info}
          />
        )}
      </div>
      <div
        className={`cex_wallet__connect__field seo_page__sidebar__converter__field ${
          error ? 'cex_wallet__connect__field--error' : ''
        }`}
      >
        <div className={`cex_wallet__connect__field__pre ${icon}`} />
        <input
          readOnly={loading}
          type={type}
          className='field'
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={resetError}
          placeholder={placeholder}
        />
        {error && (
          <div className='cex_wallet__connect__label__icon icon-alert-triangle' />
        )}
      </div>
      <ReactTooltip
        id={`modal-input-tooltip-${label}`}
        type='light'
        place='bottom'
        effect='solid'
        className='text_tooltip'
        multiline={true}
      />
    </div>
  );
};

export default ModalInput;
